{
  "name": "regattas.admin",
  "version": "1.1.108",
  "author": "Vilius Roškus <info@regattas.eu>",
  "license": "MIT",
  "engines": {
    "node": ">=20.0.0"
  },
  "main": "dist/index.html",
  "scripts": {
    "dev": "yarn dev:pre && yarn dev:run",
    "dev:pre": "yarn conf",
    "dev:run": "build-web --input-file=src/index.tsx --serve=8080",
    "prebuild": "rm -Rf dist",
    "build": "build-web --input-file=src/index.tsx --sourcemap",
    "conf": "config-web src/config.ts dist/config.js",
    "start": "serve -s dist",
    "test": "yarn test:eslint && yarn test:type && yarn test:dead && yarn test:e2e",
    "test:eslint": "eslint src test --fix",
    "test:type": "tsc",
    "test:dead": "npm run test:deadcode && npm run test:deadfile",
    "test:deadcode": "ts-prune -i dist | grep -v '(used in module)' || echo 'No unused code!'",
    "test:deadfile": "deadfile --ci src/index.tsx --dir src --exclude theme test_e2e mocks.tsx .ttf .woff .png",
    "test:e2e": "start-server-and-test test:e2e:pre http://localhost:7001 test:e2e:run && yarn test:e2e:post",
    "test:e2e:pre": "yarn test:e2e:pre:clean && yarn test:e2e:pre:build && yarn test:e2e:pre:conf && yarn test:e2e:pre:serve",
    "test:e2e:pre:clean": "rm -rf .nyc_output coverage test_build",
    "test:e2e:pre:build": "build-web --input-file=src/index.tsx --output-dir=test_build --coverage",
    "test:e2e:pre:conf": "DEPLOYMENT_ENV=TEST config-web src/config.ts test_build/config.js",
    "test:e2e:pre:serve": "PORT=7001 serve -s test_build",
    "test:e2e:run": "CYPRESS_baseUrl=http://localhost:7001 cypress run",
    "test:e2e:post": "nyc report && compare-coverage-thresholds && jest-coverage-thresholds-bumper",
    "test:e2e:console": "CYPRESS_baseUrl=http://localhost:7001 cypress open",
    "test:e2e:report": "open coverage/lcov-report/index.html",
    "upload:sourcemaps": "upload-sourcemaps",
    "analyze": "yarn build && source-map-explorer dist/*.js --no-border-checks"
  },
  "dependencies": {
    "@fortawesome/fontawesome-free": "6.6.0",
    "@react-google-maps/api": "2.19.3",
    "@stripe/react-stripe-js": "2.8.0",
    "@stripe/stripe-js": "4.3.0",
    "@vroskus/library-api": "1.0.17",
    "@vroskus/library-components": "1.0.47",
    "@vroskus/library-cookies": "1.0.21",
    "@vroskus/library-crisp": "1.0.17",
    "@vroskus/library-error": "1.0.28",
    "@vroskus/library-helpers": "1.0.20",
    "@vroskus/library-mixpanel": "1.0.20",
    "@vroskus/library-navigation": "1.0.13",
    "@vroskus/library-sentry": "1.0.24",
    "@vroskus/library-socket": "1.0.19",
    "@vroskus/library-types": "1.0.9",
    "@vroskus/library-validator": "1.0.25",
    "animate.css": "4.1.1",
    "availity-reactstrap-validation": "2.7.1",
    "bootstrap": "5.3.3",
    "common.data": "^1.0.29",
    "common.enums": "^1.0.39",
    "common.helpers": "^1.0.51",
    "common.language": "^1.0.21",
    "common.types": "^1.0.16",
    "coordinate-parser": "1.0.7",
    "country-flag-icons": "1.5.13",
    "fast-text-encoding": "1.0.6",
    "formatcoords": "1.1.3",
    "lodash": "4.17.21",
    "moment": "2.29.4",
    "moment-timezone": "0.5.45",
    "react": "18.3.1",
    "react-app-polyfill": "3.0.0",
    "react-bootstrap-typeahead": "6.3.2",
    "react-datetime": "3.2.0",
    "react-diff-viewer": "3.1.1",
    "react-dom": "18.3.1",
    "react-facebook-login": "4.1.1",
    "react-google-login": "5.2.2",
    "react-google-recaptcha": "3.1.0",
    "react-i18next": "15.0.1",
    "react-minimal-pie-chart": "^8.4.0",
    "react-modal-image": "2.6.0",
    "react-movable": "3.3.1",
    "react-redux": "9.1.2",
    "react-router-dom": "6.26.1",
    "react-select": "5.8.0",
    "react-sortablejs": "6.1.4",
    "react-toastify": "10.0.5",
    "reactstrap": "9.2.2",
    "redux": "5.0.1",
    "redux-logger": "3.0.6",
    "redux-promise-middleware": "6.2.0",
    "redux-thunk": "3.1.0",
    "screenfull": "6.0.2",
    "simple-line-icons": "2.5.5",
    "sortablejs": "1.15.2",
    "styled-components": "6.1.12",
    "svg-classlist-polyfill": "1.1.0",
    "zod": "3.23.8"
  },
  "devDependencies": {
    "@cypress/code-coverage": "3.12.45",
    "@types/react": "18.3.3",
    "@types/react-router-dom": "5.3.3",
    "@vroskus/build-web": "1.0.22",
    "@vroskus/compare-coverage-thresholds": "1.0.6",
    "@vroskus/config-web": "1.0.9",
    "@vroskus/eslint-config": "1.0.13",
    "@vroskus/upload-sourcemaps": "1.0.9",
    "backstopjs": "6.3.23",
    "cypress": "13.9.0",
    "cypress-localstorage-commands": "2.2.6",
    "deadfile": "2.1.1",
    "eslint-plugin-cypress": "3.5.0",
    "jest": "29.7.0",
    "jest-coverage-thresholds-bumper": "1.1.0",
    "npm-check": "6.0.1",
    "nyc": "17.0.0",
    "nyc-config-tsx": "0.1.0",
    "serve": "14.2.3",
    "source-map-explorer": "2.5.3",
    "start-server-and-test": "2.0.5",
    "ts-prune": "0.10.3",
    "typescript": "5.5.4"
  },
  "nyc": {
    "all": true,
    "root": "src",
    "reporter": [
      "json-summary",
      "lcov",
      "text"
    ],
    "include": [
      "src"
    ],
    "exclude": [
      "src/theme/**/*"
    ],
    "extends": "nyc-config-tsx"
  },
  "jest": {
    "reporters": [
      "default"
    ],
    "collectCoverage": true,
    "coverageThreshold": {
      "global": {
        "branches": 13.05,
        "functions": 21.1,
        "lines": 29.99,
        "statements": 30.13
      }
    }
  },
  "uploadSourcemapsConfig": {
    "org": "regattas",
    "project": "regattas-admin",
    "authToken": "90abb973f6564ad6aa6ce40cc112055d8531ae56bd564811b7f4ba7fae5c7d35",
    "filesPath": "dist"
  },
  "browserslist": [
    ">0.2%",
    "not dead",
    "not ie <= 11",
    "not op_mini all"
  ]
}
